module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0074.jpg?v=2c37e3ce";